import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./Insights.css";

import Sub_img1 from "../../images/Sub-img-1.png"
import Sub_img2 from "../../images/Sub-img-2.png" 
import Sub_img3 from "../../images/Sub-img-3.png"
import Sub_img4 from "../../images/Sub-img-4.png"
import Sub_img5 from "../../images/Sub-img-5.png"
import Sub_img6 from "../../images/Sub-img-6.png"
import Sub_img7 from "../../images/Sub-img-7.png"
import Sub_img8 from "../../images/Sub-img-8.png"
import Sub_img9 from "../../images/Sub-img-9.png"
import Sub_img10 from "../../images/Sub-img-10.png"


const Insights = () => {

// open page on top //
 useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // open page on top // 

  const navigate = useNavigate();

  const handleReadMore = () => {
    navigate("/Blogs-Pages/Blog_Registration", {
      state: { scrollToContact: true },
    });
  };
  const handleReadMore2 = () => {
    navigate("/Blogs-Pages/Blog_CompGuide", {
      state: { scrollToContact: true },
    });
  };
  const handleReadMore3 = () => {
    navigate("/Blogs-Pages/Blog_Beginners", {
      state: { scrollToContact: true },
    });
  };
  const handleReadMore4 = () => {
    navigate("/Blogs-Pages/Blog_Business", {
      state: { scrollToContact: true },
    });
  };
  const handleReadMore5 = () => {
    navigate("/Blogs-Pages/Blog_Compliance", {
      state: { scrollToContact: true },
    });
  };
  const handleReadMore6 = () => {
    navigate("/Blogs-Pages/Blog_DocNeeded", {
      state: { scrollToContact: true },
    });
  };
  const handleReadMore7 = () => {
    navigate("/Blogs-Pages/Blog_GuideSteps", {
      state: { scrollToContact: true },
    });
  };
  const handleReadMore8 = () => {
    navigate("/Blogs-Pages/Blog_RegManager", {
      state: { scrollToContact: true },
    });
  };
  const handleReadMore9 = () => {
    navigate("/Blogs-Pages/Blog_RegTake", {
      state: { scrollToContact: true },
    });
  };
   const handleReadMore10 = () => {
     navigate("/Blogs-Pages/Blog_Capital_Allowance", {
       state: { scrollToContact: true },
     });
   };

  return (
    <>
      <div className="Insights">
        <div className="Insights-card">
          <h1 className="Insights-title">Insights & Blogs</h1>
          <p className="Insights-pera">
            Our advice is built on real experience within the care sector,
            including operating seven care homes across the South of England,
            with <br />
            continued growth planned across the UK. We understand that
            delivering high-quality care alongside strong operational
            performance <br />
            creates stable, sustainable services, and with the right guidance,
            managing a successful care business becomes far more achievable.
          </p>

          <div className="Insights-page">
            <div className="Insights-card">
              <section className="Insights-section">
                <div className="Insights-image">
                  <img src={Sub_img1} alt="" />
                </div>
                <div className="Insights-box">
                  <h2>
                    The CQC Registration Process Has Changed in 2026 What New
                    Care Providers Need to Know
                  </h2>
                  <p>
                    {" "}
                    The Care Quality Commission registration process has seen
                    steady changes over the last 12 months, with a stronger
                    focus on application quality, supporting evidence, and
                    provider readiness. New measures introduced by the CQC mean
                    more applications are being rejected at the initial stage,
                    requiring providers to resubmit and rejoin the queue.
                    Stricter validation checks, and updated frameworks have been
                    designed to raise standards across the sector. In this
                    guide, we explore the key changes introduced in 2026 and
                    what care providers need to do to prepare for a successful
                    registration process.
                  </p>
                  <button className="Insights-btn" onClick={handleReadMore}>
                    Read More{" "}
                  </button>
                </div>
              </section>
              <section className="Insights-section reverse">
                <div className="Insights-image">
                  <img src={Sub_img2} alt="" />
                </div>
                <div className="Insights-box">
                  <h2>A Complete Guide to the Care Quality Commission (CQC)</h2>
                  <p>
                    Maintaining compliance with the Care Quality Commission is a
                    vital part of running a successful care service. From
                    meeting the Fundamental Standards to preparing for
                    inspections and maintaining accurate policies and
                    procedures, understanding what’s expected can feel
                    challenging. This complete guide explores the key areas of
                    CQC compliance, helping care providers improve service
                    quality, stay inspection-ready, and build confidence in
                    delivering safe, effective, and person-centred care.
                  </p>
                  <button className="Insights-btn" onClick={handleReadMore2}>
                    Read More{" "}
                  </button>
                </div>
              </section>
              <section className="Insights-section">
                <div className="Insights-image">
                  <img src={Sub_img3} alt="" />
                </div>
                <div className="Insights-box">
                  <h2>
                    What is CQC Registration? A Beginner’s Guide to Registering
                    Your Care Service
                  </h2>
                  <p>
                    Starting a care business can feel overwhelming, especially
                    when it comes to navigating CQC registration requirements.
                    Whether you're launching a domiciliary care agency,
                    supported living service, or residential care home,
                    understanding the registration process is essential for
                    operating legally and confidently. In this beginner’s guide,
                    we’ll break down the key steps involved in registering with
                    the Care Quality Commission, explain what documents and
                    policies you’ll need, and share practical tips to help you
                    avoid common mistakes along the way.
                  </p>
                  <button className="Insights-btn" onClick={handleReadMore3}>
                    Read More{" "}
                  </button>
                </div>
              </section>
              <section className="Insights-section reverse">
                <div className="Insights-image">
                  <img src={Sub_img4} alt="" />
                </div>
                <div className="Insights-box">
                  <h2>
                    How to Start a Care Business in the UK (Complete
                    Step-by-Step Guide)
                  </h2>
                  <p>
                    Starting a care business in the UK can be a rewarding
                    opportunity, allowing you to provide essential support
                    services while building a sustainable and profitable
                    organisation. However, entering the health and social care
                    sector requires careful planning, regulatory compliance, and
                    a strong understanding of industry standards.Whether you
                    plan to offer domiciliary care, supported living services,
                    residential care, or specialist healthcare support, you must
                    meet legal requirements, develop robust policies, and obtain
                    the necessary registrations before providing care services.
                  </p>
                  <button className="Insights-btn" onClick={handleReadMore4}>
                    Read More{" "}
                  </button>
                </div>
              </section>
              <section className="Insights-section">
                <div className="Insights-image">
                  <img src={Sub_img5} alt="" />
                </div>
                <div className="Insights-box">
                  <h2>
                    The Complete Guide to CQC Compliance for Care Providers
                  </h2>
                  <p>
                    CQC compliance is a fundamental requirement for all health
                    and social care providers operating in England. The Care
                    Quality Commission (CQC) regulates care services to ensure
                    they deliver safe, effective, caring, responsive, and
                    well-led care that meets the needs of service
                    users.Achieving and maintaining compliance involves much
                    more than obtaining registration. Providers must implement
                    robust policies, effective governance systems, staff
                    training programmes, risk management procedures, and quality
                    assurance processes that align with CQC regulations and
                    inspection expectations.
                  </p>
                  <button className="Insights-btn" onClick={handleReadMore5}>
                    Read More{" "}
                  </button>
                </div>
              </section>
              <section className="Insights-section reverse">
                <div className="Insights-image">
                  <img src={Sub_img6} alt="" />
                </div>
                <div className="Insights-box">
                  <h2>
                    Documents Needed for CQC Registration in 2026: Complete
                    Checklist for Care Providers
                  </h2>
                  <p>
                    Preparing the correct documentation is one of the most
                    important steps in the Care Quality Commission (CQC)
                    registration process. Incomplete applications, missing
                    evidence, or poorly prepared policies can lead to delays,
                    additional information requests, and unnecessary
                    complications during registration.Whether you are launching
                    a domiciliary care agency, supported living service,
                    residential care home, or specialist healthcare provider,
                    having the right documents in place demonstrates your
                    ability to deliver safe, effective, and well-managed care in
                    line with CQC regulations.
                  </p>
                  <button className="Insights-btn" onClick={handleReadMore6}>
                    Read More{" "}
                  </button>
                </div>
              </section>
              <section className="Insights-section">
                <div className="Insights-image">
                  <img src={Sub_img7} alt="" />
                </div>
                <div className="Insights-box">
                  <h2>
                    How to Register with CQC in 2026: Complete Step-by-Step
                    Guide for New Care Providers
                  </h2>
                  <p>
                    {" "}
                    Registering with the Care Quality Commission (CQC) is a
                    legal requirement for most health and social care providers
                    operating in England. Whether you are starting a domiciliary
                    care agency, supported living service, care home, healthcare
                    clinic, or specialist care organisation, obtaining CQC
                    registration is a crucial step before delivering regulated
                    activities.The registration process can appear complex,
                    particularly for first-time providers.
                  </p>
                  <button className="Insights-btn" onClick={handleReadMore7}>
                    Read More{" "}
                  </button>
                </div>
              </section>
              <section className="Insights-section reverse">
                <div className="Insights-image">
                  <img src={Sub_img8} alt="" />
                </div>
                <div className="Insights-box">
                  <h2>
                    CQC Registration for Managers: Everything You Need to Know
                  </h2>
                  <p>
                    Planning to become a Registered Manager or responsible
                    leader for a care service? This comprehensive guide to CQC
                    Registration for Managers covers everything you need to
                    know, including eligibility requirements, qualifications,
                    DBS checks, fitness assessments, interview preparation,
                    application steps, and ongoing responsibilities. Whether
                    you're registering a new service or taking over an existing
                    one, learn how to navigate the CQC registration process
                    confidently, avoid common mistakes, and ensure compliance
                    with the latest 2026 regulations.{" "}
                  </p>
                  <button className="Insights-btn" onClick={handleReadMore8}>
                    Read More{" "}
                  </button>
                </div>
              </section>
              <section className="Insights-section">
                <div className="Insights-image">
                  <img src={Sub_img9} alt="" />
                </div>
                <div className="Insights-box">
                  <h2>
                    How Long Does CQC Registration Take? Complete Timeline Guide
                  </h2>
                  <p>
                    Wondering how long CQC registration takes? Learn the
                    complete CQC registration timeline, typical processing
                    times, key stages, common delays, and practical tips to
                    speed up approval for your care business in England.Planning
                    a new care service? Discover how long CQC registration
                    takes, what happens at each stage of the application
                    process, factors that affect approval times, and how to
                    avoid common registration delays.
                  </p>
                  <button className="Insights-btn" onClick={handleReadMore9}>
                    Read More{" "}
                  </button>
                </div>
              </section>
              <section className="Insights-section reverse">
                <div className="Insights-image">
                  <img src={Sub_img10} alt="" />
                </div>
                <div className="Insights-box">
                  <h2>
                    Capital Allowances for Care Homes: Are You Missing Out on
                    Valuable Tax Relief?
                  </h2>
                  <p>
                    If you own, purchase or refurbish a care home, you may be
                    entitled to valuable capital allowances that have not yet
                    been identified or claimed. <br /> <br /> Many care-home
                    operators assume that their accountant will automatically
                    identify every qualifying item within a property. However,
                    specialist property capital allowances can require a
                    detailed review of the building, its fixtures, the purchase
                    documentation and previous claims.
                  </p>
                  <button className="Insights-btn" onClick={handleReadMore10}>
                    Read More{" "}
                  </button>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Insights;